// TODO: To be done in another ticket
import { FC } from 'react';

const ContactPhonesUS: FC = () => {
    return <></>;
};

export default ContactPhonesUS;
